<!--声光报警参数Tab-->

<template>
  <el-form v-if="alarmParam">
    <el-col :span="8">
      <el-form-item :label="$t('报警级别')" prop="alarmLevel">
        {{ $t(fourGSensorAlarmLevel[alarmParam.alarmLevel].title) }}
      </el-form-item>
    </el-col>

    <template v-if="alarmParam.alarmLevel !== 0">
      <!--    报警次数-->
      <el-col :span="8">
        <el-form-item :label="$t('报警次数')" prop="alarmCycle">
          {{ alarmParam.alarmCycle }}
        </el-form-item>
      </el-col>

      <!--    报警间隔-->
      <el-col :span="8">
        <el-form-item :label="$t('报警间隔')" prop="alarmInterval">
          {{ alarmParam.alarmInterval }}
        </el-form-item>
      </el-col>

      <!--    报警持续时间-->
      <el-col :span="8">
        <el-form-item :label="$t('报警持续时间')" prop="alarmDuration">
          {{ alarmParam.alarmDuration }}
        </el-form-item>
      </el-col>
    </template>
  </el-form>
</template>

<script>
import { fourGSensorAlarmLevel } from '@/utils/dict/sensor'

export default {
  props: {
    detailData: {}
  },
  computed: {
    fourGSensorAlarmLevel () {
      return fourGSensorAlarmLevel
    },
    alarmParam () {
      return this.detailData.alarmConfig
    }
  }
}
</script>
